import { forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useSelector } from 'store/hooks/useSelector'
import { selectPharmacySearchDaw } from '../../../../../../store/flags/FlagsSelectors'
import { usePharmacyV2Search } from 'hooks/usePharmacyV2Search'
import { PharmacyZipFilterRow } from 'components/pharmacy-zip-filter-row/PharmacyZipFilterRow'
import moment from 'moment'
import './EditModeAccountInformationView.scss'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { InputText } from 'ui_kit_qmd'
import { getTabId, getAddressValue, getPharmacyAddressValue } from '../../../../../../utils/common'
import {
  APPOINTMENT_TYPE_PHONE,
  CHARTS_EMAIL_SORT_CONDITION,
  EMERGENCY_CONTACT_TEXT,
  FIRST_NAME_TEXT,
  LAST_NAME_TEXT,
  NO_RESULTS_TEXT,
  PHONE_NUMBER_TEXT,
  PREFERRED_NAME_TEXT,
  PREFFERED_PHARMACY_TEXT,
  RELATIONSHIP_TO_PATIENT_TEXT,
  STREET_ADDRESS_TEXT,
} from '../../../../../../utils/constants'
import { text } from '../../../Constants'
import { PatientEditInfoCard } from '../../../../../../components/patient-edit-info-card/PatientEditInfoCard'
import { checkPhone, searchPharmacies } from '../../../../../../store/charts/ChartsThunk'
import { PhoneInput } from '../../../../../../components/phone-input/PhoneInput'
import {
  resetPharmacySearchList,
  setIsPharmacySearchingDone,
  setIsPhoneCorrect,
} from '../../../../../../store/charts/ChartsActions'
import { errorCodes, getUserFriendlyErrorMessage } from '../../../../../../utils/errormessages'
import { PharmacyDropdownItem } from '../../../../../../components/pharmacy-dropdown-item/PharmacyDropdownItem'

const firstInputContainerStyle = {
  marginTop: 16,
}

const inputContainerStyle = {
  marginTop: 44,
  width: '100%',
}

export const EditModeAccountInformationView = forwardRef(
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  ({ accountInfoData, isCheckNumberInProgress, setIsCheckNumberInProgress, setAccountInfoData }, ref) => {
    const params = new URLSearchParams(window.location.search)
    const id = params.get('id')
    const tabId = getTabId()
    // @ts-expect-error TS2538 -- MIGRATION: not approved, fix when encountered
    const error = useSelector((state) => state.chartsReducer.patientInfo[id]?.error || '')

    const dispatch = useDispatch()

    const isPharmacySearchDaw = useSelector(selectPharmacySearchDaw)
    // @ts-expect-error TS2538 -- MIGRATION: not approved, fix when encountered
    const patientInfo = useSelector((state) => state.chartsReducer.patientInfo[id] || {})
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    const isPhoneCorrect = useSelector((state) => state.chartsReducer.isPhoneCorrect)
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    const checkedPhoneNumber = useSelector((state) => state.chartsReducer.checkedPhoneNumber)
    const loading = useSelector((state) => state.chartsReducer.loading)
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    const foundPharmaciesCollection = useSelector((state) => state.chartsReducer.foundPharmaciesCollection)
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    const isPharmacySearchingDone = useSelector((state) => state.chartsReducer.isPharmacySearchingDone)
    // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
    const isAccountInfoUpdatedSuccess = useSelector((state) => state.chartsReducer.isAccountInfoUpdatedSuccess)

    const patientAddressZip = patientInfo?.Address?.Zip ?? ''

    const [contactPharmacyValue, setContactPharmacyValue] = useState(accountInfoData?.contactPharmacyValue)
    const [contactPharmacyValueBeforInputBlured, setContactPharmacyValueBeforeInputBlured] = useState(
      accountInfoData?.contactPharmacyValue,
    )
    const [selectedPharmacyAddress, setSelectedPharmacyAddress] = useState(accountInfoData?.selectedPharmacyAddress)

    const [contactPharmacyLocalError, setContactPharmacyLocalError] = useState('')
    const [selectedPharmacyId, setSelectedPharmacyId] = useState(accountInfoData.selectedPharmacy)
    const [selectedPharmacy, setSelectedPharmacy] = useState(accountInfoData.selectedPharmacyId)
    const [isContactPharmacySearchInputFocused, setIsContactPharmacySearchInputFocused] = useState(false)
    const [isShowContactParmaciesDropdown, setIsShowContactPharmaciesDropdown] = useState(false)
    const zipInputFocusedRef = useRef(false)

    const {
      pharmacies: v2Pharmacies,
      isSearchingDone: v2SearchingDone,
      pharmacySearchZip,
      setPharmacySearchZip,
    } = usePharmacyV2Search({
      // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
      patientId: id,
      searchInput: contactPharmacyValue ?? '',
      patientZip: patientAddressZip,
      // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
      enabled: isPharmacySearchDaw,
    })
    const pharmaciesCollection = isPharmacySearchDaw ? v2Pharmacies : foundPharmaciesCollection
    const isSearchingDone = isPharmacySearchDaw ? v2SearchingDone : isPharmacySearchingDone

    const [isContactPharmaciesSearchStarted, setIsContactPharmaciesSearchStarted] = useState(false)
    const [isContactPharmaciesStartToSearch, setIsContactPharmaciesStartToSearch] = useState(false)
    const [isContactPharmacySelected, setIsContactPharmacySelected] = useState(false)
    const [isAddressValid, setIsAddressValid] = useState(false)
    const [isResetEmergency, setIsResetEmergency] = useState(false)

    const [prefferedNameValue, setPrefferedNameValue] = useState(accountInfoData.prefferedNameValue)
    const [emergencyFirstNameValue, setEmergencyFirstNameValue] = useState(accountInfoData.emergencyFirstNameValue)
    const [emergencyFistNameLocalError, setEmergencyFirstNameLocalError] = useState('')
    const [emergecyLastNameValue, setEmergencyLastNameValue] = useState(accountInfoData.emergecyLastNameValue)
    const [emergencyLastNameLocalError, setEmergencyLastNameLocalError] = useState('')
    const [emergencyRelationshipValue, setEmergencyRelationshipValue] = useState(
      accountInfoData.emergencyRelationshipValue,
    )
    const [emergencyRelationshipLocalError, setEmergencyRelationshipLocalError] = useState('')

    const [isOldNumberCorrect, setIsOldNumberCorrect] = useState('')
    const [isPhoneChanged, setIsPhoneChanged] = useState(accountInfoData.isPhoneChanged)
    const [emergencyPhoneError, setEmergencyPhoneError] = useState(accountInfoData.emergencyPhoneError)
    // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
    const [isCheckEmergencyContactSuccess, setIsCheckEmergencySuccess] = useState(false)
    const [isWatchThisLoading, setIsWatchThisLoading] = useState(false)
    const [emergencyPhoneCountryCode, setEmergencyPhoneCountryCode] = useState(
      accountInfoData.emergencyPhoneCountryCode,
    )
    const [emergencyPhoneCountry, setEmergencyPhoneCountry] = useState(accountInfoData.emergencyPhoneCountry)
    const [emergencyPhoneNumber, setEmergencyPhoneNumber] = useState(accountInfoData.emergencyPhoneNumber)
    const [dateOfBirthValue, setDateOfBirthValue] = useState(moment(patientInfo.BirthDate).format('MM/DD/YYYY'))
    const [localDOBError, setLocalDOBError] = useState('')

    useImperativeHandle(ref, () => ({
      getInfo: () => ({
        prefferedNameValue,
        emergencyFirstNameValue,
        emergecyLastNameValue,
        emergencyRelationshipValue,
        contactPharmacyValue,
        emergencyPhoneNumber,
        selectedPharmacyAddress,
        emergencyPhoneError,
        emergencyPhoneCountryCode,
        emergencyPhoneCountry,
        selectedPharmacyId,
        selectedPharmacy,
        isPhoneChanged,
        isResetEmergency,
        dateOfBirthValue,
      }),
    }))

    useEffect(() => {
      if (isWatchThisLoading) {
        if (loading) {
          setIsCheckNumberInProgress(true)
        } else if (isCheckNumberInProgress) {
          setTimeout(() => setIsCheckNumberInProgress(false), 150)
          setIsOldNumberCorrect(isPhoneCorrect)
        }
      }
    }, [loading])

    useEffect(() => {
      setContactPharmacyValue(accountInfoData?.contactPharmacyValue)
      setContactPharmacyValueBeforeInputBlured(accountInfoData?.contactPharmacyValue)
      setSelectedPharmacyAddress(accountInfoData?.selectedPharmacyAddress)
      setSelectedPharmacyId(accountInfoData.selectedPharmacy || null)
      setSelectedPharmacy(accountInfoData.selectedPharmacyId || null)
    }, [accountInfoData])

    useEffect(() => {
      if (patientInfo) {
        setIsAddressValid(!!patientInfo?.Address)
      }
    }, [patientInfo])

    useEffect(() => {
      if (
        !emergencyFirstNameValue?.trim() &&
        !emergecyLastNameValue?.trim() &&
        !emergencyRelationshipValue?.trim() &&
        !emergencyPhoneNumber?.trim()
      ) {
        setIsResetEmergency(true)
      } else {
        setIsResetEmergency(false)
      }
    }, [emergencyFirstNameValue, emergecyLastNameValue, emergencyRelationshipValue, emergencyPhoneNumber])

    useEffect(() => {
      if (isResetEmergency) {
        setEmergencyFirstNameLocalError('')
        setEmergencyLastNameLocalError('')
        setEmergencyRelationshipLocalError('')
        setEmergencyPhoneError('')
      }
    }, [isResetEmergency])

    useEffect(() => {
      setEmergencyFirstNameLocalError('')
    }, [emergencyFirstNameValue])

    useEffect(() => {
      setEmergencyLastNameLocalError('')
    }, [emergecyLastNameValue])

    useEffect(() => {
      setEmergencyRelationshipLocalError('')
    }, [emergencyRelationshipValue])

    useEffect(() => {
      if (contactPharmacyValue !== contactPharmacyValueBeforInputBlured) {
        setIsShowContactPharmaciesDropdown(true)
      }
      if (!contactPharmacyValue) {
        setIsContactPharmaciesSearchStarted(false)
        dispatch(setIsPharmacySearchingDone(false))
      }
      if (isContactPharmacySearchInputFocused) {
        if (!isContactPharmaciesSearchStarted) {
          setIsContactPharmaciesSearchStarted(true)
          setIsContactPharmacySelected(false)
        }
        const timer = setTimeout(() => {
          setIsContactPharmaciesStartToSearch(true)
        }, 500)
        return () => clearTimeout(timer)
      } else {
        dispatch(resetPharmacySearchList())
      }
    }, [contactPharmacyValue])

    useEffect(() => {
      if (!isContactPharmacySearchInputFocused) {
        setContactPharmacyValueBeforeInputBlured(contactPharmacyValue)
        if (!zipInputFocusedRef.current) {
          setTimeout(() => {
            setIsShowContactPharmaciesDropdown(false)
          }, 300)
        }
        zipInputFocusedRef.current = false
      }
    }, [isContactPharmacySearchInputFocused])

    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    const adaptationSymbolsForAPI = (textValue) =>
      encodeURIComponent(textValue).replace(/[!'()*]/g, (c) => `%${c.charCodeAt(0).toString(16)}`)

    useEffect(() => {
      if (isPharmacySearchDaw) return
      if (isContactPharmaciesStartToSearch) {
        setIsContactPharmaciesStartToSearch(false)
        dispatch(
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          searchPharmacies(contactPharmacyValue.length > 2 ? adaptationSymbolsForAPI(contactPharmacyValue) : '', id),
        )
      }
    }, [isContactPharmaciesStartToSearch])

    useEffect(() => {
      if (accountInfoData?.isError) {
        const DOBValuesList = dateOfBirthValue?.split('/').filter((value) => value)
        const monthDOBValue = DOBValuesList?.[0]
        const dateDOBValue = DOBValuesList?.[1]
        const yearDOBValue = DOBValuesList?.[2]
        if (
          (selectedPharmacyAddress && !contactPharmacyValue?.trim()) ||
          contactPharmacyValue !== selectedPharmacyAddress
        ) {
          setContactPharmacyLocalError(
            // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
            getUserFriendlyErrorMessage(errorCodes.ENTER_VALID, null, PREFFERED_PHARMACY_TEXT.toLocaleLowerCase()),
          )
        }
        if (dateOfBirthValue?.length === 0) {
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          setLocalDOBError(getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, 'date of birth'))
        }
        if (
          (DOBValuesList?.length < 3 ||
            !moment(`${dateDOBValue}-${monthDOBValue}-${yearDOBValue}`, 'DD-MM-YYYY').isValid() ||
            // @ts-expect-error TS18048 -- MIGRATION: not approved, fix when encountered
            yearDOBValue?.length < 4 ||
            moment(`${dateDOBValue}-${monthDOBValue}-${yearDOBValue}`, 'DD-MM-YYYY').isAfter(new Date()) ||
            moment(`${dateDOBValue}-${monthDOBValue}-${yearDOBValue}`, 'DD-MM-YYYY').isBefore('1901-01-01', 'year')) &&
          dateOfBirthValue?.length !== 0
        ) {
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          setLocalDOBError(getUserFriendlyErrorMessage(errorCodes.ENTER_VALID, null, 'date of birth'))
        }
      }

      if (accountInfoData?.isEmergencyContactError) {
        const isNumberTheSameAsPatientsNumber =
          patientInfo?.PhoneNumber?.Number === `+${emergencyPhoneCountryCode}${emergencyPhoneNumber}`

        if (
          !emergencyFirstNameValue?.trim() ||
          !emergecyLastNameValue?.trim() ||
          !emergencyRelationshipValue?.trim() ||
          !emergencyPhoneNumber?.trim() ||
          isNumberTheSameAsPatientsNumber
        ) {
          if (!emergencyFirstNameValue?.trim()) {
            setEmergencyFirstNameLocalError(
              // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
              getUserFriendlyErrorMessage(errorCodes.ALL_FIELDS_MUST_BE_POPULATED, null, EMERGENCY_CONTACT_TEXT),
            )
          }

          if (!emergecyLastNameValue?.trim()) {
            setEmergencyLastNameLocalError(
              // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
              getUserFriendlyErrorMessage(errorCodes.ALL_FIELDS_MUST_BE_POPULATED, null, EMERGENCY_CONTACT_TEXT),
            )
          }

          if (!emergencyRelationshipValue?.trim()) {
            setEmergencyRelationshipLocalError(
              // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
              getUserFriendlyErrorMessage(errorCodes.ALL_FIELDS_MUST_BE_POPULATED, null, EMERGENCY_CONTACT_TEXT),
            )
          }

          if (!emergencyPhoneNumber?.trim()) {
            setEmergencyPhoneError(
              // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
              getUserFriendlyErrorMessage(errorCodes.ALL_FIELDS_MUST_BE_POPULATED, null, EMERGENCY_CONTACT_TEXT),
            )
          }

          if (isNumberTheSameAsPatientsNumber) {
            setEmergencyPhoneError(getUserFriendlyErrorMessage(errorCodes.PHONE_NOT_UNIQUE))
          }
        } else {
          setIsCheckEmergencySuccess(true)
        }
      }
    }, [accountInfoData])

    useEffect(() => {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      if (error === getUserFriendlyErrorMessage(errorCodes.ENTER_VALID, null, text.PHONE_NUMBER)) {
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        setEmergencyPhoneError(getUserFriendlyErrorMessage(errorCodes.ENTER_VALID, null, text.PHONE_NUMBER))
      }
    }, [error])

    const checkNumberAction = () => {
      dispatch(
        checkPhone({
          number: emergencyPhoneNumber,
          phoneCoutryCode: emergencyPhoneCountryCode,
          country: emergencyPhoneCountry,
          tabId,
        }),
      )
    }

    const setIsPhoneCorrectAction = () => {
      // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
      dispatch(setIsPhoneCorrect())
    }

    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    const onChangeCountry = (code, country) => {
      setEmergencyPhoneCountryCode(code)
      setEmergencyPhoneCountry(country.countryCode)
      setIsPhoneChanged(true)
      setIsWatchThisLoading(true)
      if (emergencyPhoneNumber) {
        setIsPhoneCorrectAction()
        dispatch(
          checkPhone({
            number: emergencyPhoneNumber,
            phoneCoutryCode: code,
            country: country.countryCode,
            tabId,
          }),
        )
      }
    }

    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    const onChangeNumber = (value) => {
      if (!isNaN(value) && value[value.length - 1] !== '.') {
        setEmergencyPhoneError('')
        setIsWatchThisLoading(true)
        setEmergencyPhoneNumber(value)
        setIsPhoneChanged(true)
        setIsPhoneCorrectAction()
      }
    }

    const onBlurDOBInput = () => {
      if (dateOfBirthValue === '//') {
        setDateOfBirthValue('')
      }
    }

    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    const onChangeDOB = (value) => {
      const resultValuesList = []
      const separatedDOBValues = value.split('/')
      const month = separatedDOBValues?.[0]
      const date = separatedDOBValues?.[1]
      const year = separatedDOBValues?.[2]

      if (month?.length === 2) {
        if (Number(month) > 12 && (year?.length === 4 || !year?.length)) {
          resultValuesList.push('12')
        } else if (Number(month) < 1 && (year?.length === 4 || !year?.length)) {
          resultValuesList.push('01')
        } else {
          resultValuesList.push(month)
        }
      } else {
        resultValuesList.push(month)
      }

      if (date?.length === 2) {
        if (Number(date) > 31 && (year?.length === 4 || !year?.length)) {
          resultValuesList.push('31')
        } else if (Number(date) < 1 && (year?.length === 4 || !year?.length)) {
          resultValuesList.push('01')
        } else {
          resultValuesList.push(date)
        }
      } else {
        resultValuesList.push(date)
      }

      if (year?.length === 4) {
        if (Number(year) > Number(moment(new Date()).format('YYYY'))) {
          resultValuesList.push(moment(new Date()).format('YYYY'))
        } else if (Number(year) < 1901) {
          resultValuesList.push('1901')
        } else {
          resultValuesList.push(year)
        }
      } else {
        resultValuesList.push(year)
      }

      setLocalDOBError('')
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      setAccountInfoData((prev) => ({ ...prev, isError: false }))
      setDateOfBirthValue(resultValuesList.join('/'))
    }

    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    const onSetContactPharmacyValue = useCallback((inputValue) => {
      setContactPharmacyValue(inputValue)
      setContactPharmacyLocalError('')
    }, [])

    const setPharmacyString = useCallback(
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      (pharmacyConfig) =>
        `${pharmacyConfig?.Address?.StreetAddress1}, ${
          pharmacyConfig?.Address?.StreetAddress2 ? `${pharmacyConfig?.Address?.StreetAddress2}, ` : ''
        }${pharmacyConfig?.Address?.City}, ${pharmacyConfig?.Address?.StateCode} ${pharmacyConfig?.Address?.Zip}, ${
          pharmacyConfig?.Address?.CountryCode
        }`,
      [],
    )

    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    const onSelectPharmacy = useCallback((selectedPharmacyConfig) => {
      setSelectedPharmacy(selectedPharmacyConfig)
      setSelectedPharmacyId(selectedPharmacyConfig.PharmacyId)
      setContactPharmacyValue(getPharmacyAddressValue(selectedPharmacyConfig))
      setSelectedPharmacyAddress(getPharmacyAddressValue(selectedPharmacyConfig))
    }, [])

    return (
      <>
        {/*
         // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered */}
        <PatientEditInfoCard title={text.PERSONAL}>
          <InputText
            label={FIRST_NAME_TEXT}
            containerStyle={{ ...inputContainerStyle, ...firstInputContainerStyle }}
            value={patientInfo.FirstName}
            localError={false}
            view='visitType'
            disabled
          />
          <InputText
            label={LAST_NAME_TEXT}
            containerStyle={inputContainerStyle}
            value={patientInfo.LastName}
            localError={false}
            view='visitType'
            disabled
          />
          <InputText
            label={PREFERRED_NAME_TEXT}
            maxLength={50}
            containerStyle={inputContainerStyle}
            setValue={setPrefferedNameValue}
            value={prefferedNameValue}
            view='visitType'
          />
          <InputText
            mask='99/99/9999'
            label={text.DOB_WITH_FORMAT}
            containerStyle={inputContainerStyle}
            setValue={onChangeDOB}
            onUserBlur={onBlurDOBInput}
            value={dateOfBirthValue}
            localError={localDOBError}
            view='visitType'
          />
        </PatientEditInfoCard>
        {/*
         // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered */}
        <PatientEditInfoCard title={text.CONTACT} isTooltipOutside>
          <PhoneInput
            // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
            id='edit-mode-account-information-view-phone-container'
            className='edit-mode-account-information-view-contact-phone'
            inputLabel={APPOINTMENT_TYPE_PHONE}
            phoneCountry={patientInfo.PhoneNumber?.CountryCode?.toLowerCase() ?? 'us'}
            phoneNumber={patientInfo.PhoneNumber?.Number?.substr(patientInfo.PhoneNumber?.Prefix?.length ?? 0) ?? ''}
            phoneCountryCode={patientInfo.PhoneNumber?.Prefix?.substr(1) ?? ''}
            disabled
          />
          <InputText
            label={CHARTS_EMAIL_SORT_CONDITION}
            containerStyle={inputContainerStyle}
            value={patientInfo.Email}
            localError={false}
            view='visitType'
            disabled
          />
          <InputText
            label={STREET_ADDRESS_TEXT}
            containerStyle={inputContainerStyle}
            value={getAddressValue(patientInfo.Address)}
            localError={false}
            view='visitType'
            disabled
          />
          <div className='edit-mode-account-information-view-pharmacy-input-main-wrapper'>
            <InputText
              label={PREFFERED_PHARMACY_TEXT}
              onSetIsFocused={setIsContactPharmacySearchInputFocused}
              containerStyle={inputContainerStyle}
              setValue={onSetContactPharmacyValue}
              value={contactPharmacyValue}
              isError={isAddressValid ? !!contactPharmacyLocalError : false}
              localError={isAddressValid ? contactPharmacyLocalError : ''}
              view='visitType'
              isSearch
              disabled={!isAddressValid}
            />
            {(
              isContactPharmaciesSearchStarted &&
              !isContactPharmacySelected &&
              isSearchingDone &&
              isShowContactParmaciesDropdown &&
              !contactPharmacyLocalError
            ) ?
              <div className='edit-pharmacy-list-of-pharmacies-dropdown'>
                {isPharmacySearchDaw ?
                  <PharmacyZipFilterRow
                    zipCode={pharmacySearchZip}
                    patientZipFallback={patientAddressZip}
                    onSave={setPharmacySearchZip}
                    onInteract={() => {
                      zipInputFocusedRef.current = true
                    }}
                  />
                : null}
                {
                  pharmaciesCollection?.length ?
                    <>
                      {/*
                       // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered */}
                      {pharmaciesCollection.map((pharmacyListItem, idx) => (
                        // @ts-expect-error TS2739 -- MIGRATION: not approved, fix when encountered
                        <PharmacyDropdownItem
                          key={pharmacyListItem.PharmacyId}
                          currentPharmacy={pharmacyListItem}
                          title={pharmacyListItem.Name}
                          description={setPharmacyString(pharmacyListItem)}
                          distance={pharmacyListItem.DistanceMiles}
                          onSelectPharmacy={onSelectPharmacy}
                          isTheLastItem={idx === pharmaciesCollection.length - 1}
                        />
                      ))}
                    </>
                    // @ts-expect-error TS2739 -- MIGRATION: not approved, fix when encountered
                  : <PharmacyDropdownItem title={NO_RESULTS_TEXT} isEmpty isTheLastItem />
                }
              </div>
            : null}
          </div>
        </PatientEditInfoCard>
        {/*
         // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered */}
        <PatientEditInfoCard
          className='account-information-view-edit-emergency-card'
          title={text.EMERGENCY_CONTACT}
          isTooltipOutside>
          <InputText
            label={FIRST_NAME_TEXT}
            maxLength={50}
            containerStyle={{ ...inputContainerStyle, ...firstInputContainerStyle }}
            setValue={setEmergencyFirstNameValue}
            value={emergencyFirstNameValue}
            isError={!!emergencyFistNameLocalError}
            localError={emergencyFistNameLocalError}
            view='visitType'
          />
          <InputText
            label={LAST_NAME_TEXT}
            maxLength={50}
            containerStyle={inputContainerStyle}
            setValue={setEmergencyLastNameValue}
            value={emergecyLastNameValue}
            isError={!!emergencyLastNameLocalError}
            localError={emergencyLastNameLocalError}
            view='visitType'
          />
          <InputText
            label={RELATIONSHIP_TO_PATIENT_TEXT}
            maxLength={50}
            containerStyle={inputContainerStyle}
            setValue={setEmergencyRelationshipValue}
            value={emergencyRelationshipValue}
            isError={!!emergencyRelationshipLocalError}
            localError={emergencyRelationshipLocalError}
            view='visitType'
          />
          <PhoneInput
            // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
            id='edit-mode-account-information-view-emergency-contact-phone-container'
            className='edit-mode-account-information-view-emergency-contact-phone'
            inputLabel={PHONE_NUMBER_TEXT}
            setCountryCode={setEmergencyPhoneCountryCode}
            phoneCountry={emergencyPhoneCountry}
            phoneNumber={emergencyPhoneNumber}
            phoneCountryCode={emergencyPhoneCountryCode}
            onChangeCountry={onChangeCountry}
            onChangeNumber={onChangeNumber}
            checkPhone={checkNumberAction}
            isPhoneCorrect={isPhoneCorrect}
            checkedPhoneNumber={checkedPhoneNumber}
            isOldNumberCorrect={isOldNumberCorrect}
            setIsPhoneCorrect={setIsPhoneCorrectAction}
            setPhoneError={setEmergencyPhoneError}
            error={emergencyPhoneError}
            loading={loading}
            isDisableAutocomplete
          />
        </PatientEditInfoCard>
      </>
    )
  },
)
